export const ROOT = '/BackgroundCheck';
export const LIST = `${ROOT}/getbcheckbypage`;
export const EXPORT = `${ROOT}/export`;
export const APPROVAL = `${ROOT}/approval`;
export const GET_APPLICANT_DETAIL = `${ROOT}/GetApplicantLatestDetail`;
export const SEND_EMAIL_NOTIF = `${ROOT}/sendEmailNotificationToCharRef`;